const { api } = require("@services/api");

export const getLoggedInDevices = () => api.get("/leader/get-loggedin-devices");

export const isDeviceActive = (deviceId) =>
  api.get(`/leader/is-device-active?device_id=${deviceId}`);

export const logoutLeader = (deviceId, source) => {
  const url = `/leader/logout-v2?device_id=${deviceId}&source=${source}`;
  return api.post(url);
};

export const confirmLeader = (uniqueDeviceId = "") =>
  api.post("/leader/confirm-device", { device_unique_id: uniqueDeviceId });

export const logOutCurrentDbDevice = (tl_id = "") => {
  return api.post("/leader/logout", { tl_id });
};
